import { useState } from "react";
import { User } from "./UserAccountList";
import { API_URL } from "env";
import { useTheme } from "components/provider/theme";

export interface UserEditContentProps {
    user: User;
    triggerUpdate?: () => void;
    onCancel: () => void;
}

const UserEditContent = ({ user, onCancel, triggerUpdate }: UserEditContentProps) => {
    const [firstName, setFirstName] = useState(user.firstName || '');
    const [lastName, setLastName] = useState(user.lastName || '');
    const [userEmail, setUserEmail] = useState(user.email);
    const [userPhoneNumber, setUserPhoneNumber] = useState(user.phonenumber || '');
    const { theme } = useTheme();

    const onSave = async (updatedUser: User) => {
        try {
            const updatedData = await fetch(`${API_URL}api/v1/be/user/${user.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
                body: JSON.stringify({
                    first_name: firstName,
                    last_name: lastName,
                    email: userEmail,
                    phone: userPhoneNumber,
                }),
            });
            const result = await updatedData.json();
        }
        catch (error) {
            console.error('Error updating user:', error);
            alert('Failed to update user. Please try again.');
        }
        onCancel();
        triggerUpdate && triggerUpdate();
    };

    return (
        <div className="p-4">
            <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                    <div className="col-span-1">
                        <label className="block text-sm font-medium ">First Name</label>
                        <input
                            type="text"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            placeholder="Enter First name"
                            title="First Name"
                            className={`mt-1 block py-2 px-2 w-full bg-white  border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 ${theme === 'dark' ? '!text-gray-900' : '!text-gray-900'}`}
                        />
                    </div>
                    <div className="col-span-1">
                        <label className="block text-sm font-medium ">Last Name</label>
                        <input
                            type="text"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            placeholder="Enter last name"
                            title="Last Name"
                            className={`mt-1 block py-2 px-2 w-full bg-white  border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 ${theme === 'dark' ? '!text-gray-900' : '!text-gray-900'}`}
                        />
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium ">Email</label>
                    <input
                        type="email"
                        value={userEmail}
                        onChange={(e) => setUserEmail(e.target.value)}
                        placeholder="Enter email"
                        title="Email"
                        className={`mt-1 block py-2 px-2 w-full bg-white  border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 ${theme === 'dark' ? '!text-gray-900' : '!text-gray-900'}`}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium ">Phone Number</label>
                    <input
                        type="text"
                        value={userPhoneNumber}
                        onChange={(e) => setUserPhoneNumber(e.target.value)}
                        placeholder="Enter phone number"
                        title="Phone Number"
                        className={`mt-1 block py-2 px-2 w-full bg-white  border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 ${theme === 'dark' ? '!text-gray-900' : '!text-gray-900'}`}
                    />
                </div>
                {/* <div>
                    {user.KYC}
                    {user.accountType}
                    {user.address}
                    {user.country}
                    {user.dateOfBirth}
                    {user.gender}
                    {user.jobTitle}
                    {user.isActive}
                    {user.roles && user.roles.map(role => role.name).join(', ')}
                    {user.status}
                </div> */}
                <div>
                    <button
                        onClick={() => onSave({ ...user, firstName: firstName, lastName: lastName, email: userEmail, phonenumber: userPhoneNumber })}
                        className="w-1/6 bg-blue-600 !text-white py-2 rounded-md hover:bg-blue-700 transition-colors"
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
}

export default UserEditContent;